import { render, staticRenderFns } from "./WebRTCFaceDetector.vue?vue&type=template&id=8286ce68&scoped=true"
import script from "./WebRTCFaceDetector.vue?vue&type=script&lang=js"
export * from "./WebRTCFaceDetector.vue?vue&type=script&lang=js"
import style0 from "./WebRTCFaceDetector.vue?vue&type=style&index=0&id=8286ce68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8286ce68",
  null
  
)

export default component.exports